// App.tsx
import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { store } from './store/store';
import { useAppDispatch, useAppSelector } from './hooks/redux';
import { checkTokenAsync } from './store/slices/authSlice';

// Components
import Layout from './components/layout/Layout';
import LoadingScreen from './components/common/LoadingScreen';

// Pages
import LoginPage from './pages/Login/LoginPage';
import DashboardPage from './pages/Dashboard/DashboardPage';
import ObjectViewPage from './pages/ObjectView/ObjectViewPage';
import { FormViewPage } from './pages/FormView/FormViewPage';
import ReportViewPage from './pages/ReportView/ReportViewPage';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#dc004e',
    },
  },
  components: {
    MuiAppBar: {
      defaultProps: {
        elevation: 1,
      },
    },
  },
});

const AppContent: React.FC = () => {
  const dispatch = useAppDispatch();
  const { isAuthenticated, loading } = useAppSelector(state => state.auth);

  useEffect(() => {
    // Sprawdź token przy uruchomieniu aplikacji
    const token = localStorage.getItem('token');
    if (token && !isAuthenticated) {
      dispatch(checkTokenAsync());
    }
  }, [dispatch, isAuthenticated]);

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <Router>
      <Routes>
        {!isAuthenticated ? (
          <>
            <Route path="/login" element={<LoginPage />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </>
        ) : (
          <Route path="/" element={<Layout />}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<DashboardPage />} />
            
            <Route path="objects" element={<ObjectViewPage />} />
            <Route path="objects/:nodeId" element={<ObjectViewPage />} />

            {/*// =============================================================================================*/}
            {/*// ==== Dodane w Krok 3 >>>>*/}
            <Route path="forms/:formTemplateId" element={<FormViewPage />} />
            {/*// <<<< Dodane w Krok 3 ====*/}
            {/*// =============================================================================================*/}


            <Route path="object/:objectId" element={<ObjectViewPage />} />
            <Route path="form/:formId" element={<FormViewPage />} />
            <Route path="form/:formId/object/:objectId" element={<FormViewPage />} />
            <Route path="report/:reportId" element={<ReportViewPage />} />
            <Route path="report/:reportId/object/:objectId" element={<ReportViewPage />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Route>
        )}
      </Routes>
    </Router>
  );
};

const App: React.FC = () => {
  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AppContent />
      </ThemeProvider>
    </Provider>
  );
};

export default App;